import { Router } from '@reach/router';
import React from 'react';
import { AuthenticatedRoutes } from './authentication/AuthenticatedRoutes';
import { AuthenticationTokenSilentRefresh } from './authentication/AuthenticationTokenSilentRefresh';
import { loggedOutUrl, silentTokenRefreshUrl } from './authentication/authenticationUrls';
import { LoggedOut } from './authentication/LoggedOut';
import { ConfigProvider } from './config/ConfigProvider';
import { ErrorBoundary } from './ErrorBoundary';
import { PortalRoots } from './PortalRoots';
import { GlobalStyles } from './styling/GlobalStyles';

export const App = () => {
  return (
    <>
      <React.StrictMode>
        <GlobalStyles />
        <ErrorBoundary logErrorsToApplicationInsights={false}>
          <ConfigProvider>
            <ErrorBoundary logErrorsToApplicationInsights={true}>
              <Router primary={true}>
                <AuthenticatedRoutes path="/*" />
                <AuthenticationTokenSilentRefresh path={silentTokenRefreshUrl} />
                <LoggedOut path={loggedOutUrl} />
              </Router>
            </ErrorBoundary>
          </ConfigProvider>
        </ErrorBoundary>
      </React.StrictMode>
      <PortalRoots />
    </>
  );
};
